import { VideoLayoutTimeline } from '@sparemin/api-sdk';
import { Map } from 'immutable';
import memoize from 'memoizee';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { videoLayoutTimelineSchema } from 'redux/middleware/api/media-upload-service/schemas';
import { State } from 'redux/types';
import { DeepImmutableMap } from 'types';
import { entitiesSelector } from './base';

export type ImmutableVideoLayoutTimeline = DeepImmutableMap<
  VideoLayoutTimeline
>;

export type VideoLayoutTimelineById = Map<string, ImmutableVideoLayoutTimeline>;

const normalizedVideoLayoutTimelineSelector = (state: State) =>
  entitiesSelector(state).get('videoLayoutTimeline');

export const videoLayoutTimelineDataByIdSelector = createSelector(
  entitiesSelector,
  normalizedVideoLayoutTimelineSelector,
  (entities, videoLayoutTimeline): VideoLayoutTimelineById =>
    denormalize(videoLayoutTimeline, videoLayoutTimelineSchema, entities),
);

export const getVideoLayoutTimelineSelector = memoize((uuid: string) =>
  createSelector(
    videoLayoutTimelineDataByIdSelector,
    videoLayoutTimelineDataById => videoLayoutTimelineDataById?.get(uuid),
  ),
);

export const getVideoLayoutTimelineRevisionIdSelector = memoize(
  (uuid: string) =>
    createSelector(getVideoLayoutTimelineSelector(uuid), videoLayoutTimeline =>
      videoLayoutTimeline?.get('revisionId'),
    ),
);

export const getVideoLayoutTimelineSegmentIdsSelector = memoize(
  (uuid: string) =>
    createSelector(
      getVideoLayoutTimelineSelector(uuid),
      videoLayoutTimeline =>
        videoLayoutTimeline
          .get('data')
          .map(segment => segment.get('segmentId'))
          .toJS() as string[],
    ),
);
